import TwoComponentPage from './TwoComponentPage'

export default TwoComponentPage
